export enum PreviousOwnerUsageHistoryOptions {
	BUSINESS = "BUSINESS",
	OTHER = "OTHER",
	PRIVATE = "PRIVATE",
	RENTAL = "RENTAL",
}
